window.odTheme = window.odTheme || {};

window.odTheme.FreeSeedPromo = (function() {
  
  function FreeSeedPromo(cart){
    this.update(cart);
  }

  FreeSeedPromo.prototype = $.extend({}, FreeSeedPromo.prototype, {
    update: function(cart){
      const self = this;

      self.data = {
        enabled: window.odTheme.customer['enable-free-seed-promo'],
        displayInCart: false,
        seedMaximum: window.odTheme.customer['free-seed-maximum'],
        seedCount: 0,
        seedCount: 0,
        seedsLeft: window.odTheme.customer['free-seed-maximum'],
        freeSeedIds: [],
        isLoggedIn: window.odTheme.customer && window.odTheme.customer.loggedIn,
        hasMembershipTag: self.checkMembershipTag()
      }

      if (self.data.enabled == false) {
        self.data.displayInCart = false;
        return self;
      }

      self.data.hasRedeemed = self.checkRedeemptionTag();
      if (self.data.hasMembershipTag){
        if (self.data.hasRedeemed) {
          self.data.displayInCart = false;
        }
        else {
          self.data.displayInCart = true;
        }
      }


      if (self.data.enabled){
        self.getCartFreeSeedProducts(cart);
        return self;
      }
    },

    checkRedeemptionTag: function(){
      const self = this;

    if (self.data.hasMembershipTag) {
        const customer = window.odTheme.customer;
        if (customer && customer.tags) {
          console.log("here Free Seed tag redemption")
            // Check if the tag exists
            if (customer.tags.includes(customer['free-seed-redemption-tag'])) {
                return true;
            }
        }

        // Check if the metafield (list of strings) contains the value
        if (customer && customer.metafields) {

          const metafield = customer.metafields.find(m => m.key === "free_seed_promo");
          console.log("here metafields free seed promo")
          if (metafield && metafield.value) {
              try {
                  // Parse the stringified array
                  const promoTags = JSON.parse(metafield.value);

                  if (Array.isArray(promoTags) && promoTags.includes(customer['free-seed-redemption-tag'])) {
                    console.log("here metafields free seed promo")  
                    return true;
                     
                  }
              } catch (error) {
                  console.error("Error parsing free_seed_promo metafield:", error);
              }
          }
      }
    }
    return false;
    },

    checkMembershipTag: function(){
      const self = this;

      if (window.odTheme.customer && window.odTheme.customer.tags && window.odTheme.customer.tags.length > 0){
        if (window.odTheme.customer.isMember){
          console.log("here freeseed membership")
          return true
        }
      }
      if (window.odTheme.customer.membershipInCart){
        return true
      }

      return false;
      
    },

    getCart: async function(){
      var self = this;

      return new Promise(function(resolve, reject) {

        $.ajax({
          url: '/cart?view=json',
          success: function (data) {

            var cart = JSON.parse(data);
            
            
            return resolve(cart);

          },
          error: function (XMLHttpRequest) {
            return resolve(); 
          }
        });
        
      });

    },

    getCartFreeSeedProducts: async function(cart){
      const self = this;

      cart = cart ? cart : await self.getCart();

      let freeSeedCount = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        let isFreeSeed = false;
        
        if (item.free_seed_product){
          isFreeSeed = true;
          self.data.freeSeedIds.push(item.product_id)
        }

        if (isFreeSeed){
          freeSeedCount += item.quantity;
        }
      }

      self.data.seedCount = freeSeedCount;
      self.data.seedsLeft = self.data.seedMaximum - freeSeedCount;

    }

  });

return FreeSeedPromo;

})();